import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VBreadcrumbs,{attrs:{"items":_vm.breadcrumbs,"divider":">"}}),_c('h1',{staticClass:"headline pb-4 mx-lg-auto"},[_vm._v(_vm._s(_vm.userGroup.name || 'New User Group'))]),_c(VCard,[_c(VCardText,[_c('UserGroupDetailForm',{ref:"userGroupDetailForm"})],1)],1),_c('ConfirmDialog',{attrs:{"show":_vm.showNavigateAwayConfirmDialog},on:{"confirm-dialog-clicked":_vm.confirmNavigate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }